export default "__VITE_ASSET__DLpvOU_T__"